import * as React from "react";

const Facebook = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={24} height={24} rx={7} fill="#337FFF" />
      <path d="M14.8077 12.7495L15.1497 10.5788H13.0433V9.1678C13.0433 8.57425 13.3374 7.99426 14.2777 7.99426H15.2489V6.14576C14.6833 6.05565 14.1119 6.00691 13.5391 5.99991C11.8054 5.99991 10.6735 7.04118 10.6735 8.9236V10.5788H8.75177V12.7495H10.6735V17.9999H13.0433V12.7495H14.8077Z" fill="white" />
    </svg>
  );
};

export default Facebook;
